import { render, staticRenderFns } from "./testQuestions.vue?vue&type=template&id=cc6c872c&scoped=true&"
import script from "./testQuestions.vue?vue&type=script&lang=js&"
export * from "./testQuestions.vue?vue&type=script&lang=js&"
import style0 from "./testQuestions.vue?vue&type=style&index=0&id=cc6c872c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6c872c",
  null
  
)

export default component.exports